import { useTranslations } from '@vocab/react';
import {
  Box,
  Button,
  IconPersonVerified,
  Text,
  TooltipRenderer,
} from 'braid-design-system';
import { useId, type FC } from 'react';

import { Display } from 'src/libs/Display';

import translations from '../.vocab';

interface ReferenceCheckButtonProps {
  onReferenceCheckButtonClick: () => void;
  applicationCorrelationId: string;
  isFilterExpand: boolean;
}

export const ReferenceCheckButton: FC<ReferenceCheckButtonProps> = ({
  onReferenceCheckButtonClick,
  applicationCorrelationId,
  isFilterExpand,
}) => {
  const { t } = useTranslations(translations);
  const id = useId();
  const buttonLabel = t('Check references');

  return (
    <>
      <Display mobile tablet desktop={isFilterExpand} wide={false}>
        <TooltipRenderer
          id={`${id}-tooltip`}
          tooltip={<Text>{buttonLabel}</Text>}
        >
          {({ triggerProps }) => (
            <Box {...triggerProps}>
              <Button
                id={`${id}-${applicationCorrelationId}`}
                tone="neutral"
                variant="soft"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onReferenceCheckButtonClick();
                }}
                aria-label={buttonLabel}
              >
                <IconPersonVerified />
              </Button>
            </Box>
          )}
        </TooltipRenderer>
      </Display>

      <Display desktop={!isFilterExpand} wide>
        <Button
          id={`${id}-${applicationCorrelationId}`}
          tone="neutral"
          variant="soft"
          size="small"
          icon={<IconPersonVerified />}
          onClick={(e) => {
            e.stopPropagation();
            onReferenceCheckButtonClick();
          }}
        >
          {buttonLabel}
        </Button>
      </Display>
    </>
  );
};
